import { render, staticRenderFns } from "./StoreDetails.vue?vue&type=template&id=525efdcb&scoped=true"
import script from "./StoreDetails.vue?vue&type=script&lang=js"
export * from "./StoreDetails.vue?vue&type=script&lang=js"
import style0 from "./StoreDetails.vue?vue&type=style&index=0&id=525efdcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525efdcb",
  null
  
)

export default component.exports